export default __webpack_public_path__ + "static/media/glodny-sm.5f4a8137.svg";